// extracted by mini-css-extract-plugin
export default {"groups":"index_groups__3EoTm","assignee":"index_assignee__ysfBD"};